export const FONT_STYLES_SHEETS = {
  PARLUCENT_CABRITO_OBVIOUSLY: "https://use.typekit.net/adn3ejy.css",
  OBVIOUSLY: "https://use.typekit.net/wyt1gyq.css",
};
